import React from "react";
import { StyledPricing } from "../components/Styles";
import TrueIcon from "../components/Icons/True";
import FalseIcon from "../components/Icons/False";
import Consultation from "../components/Consultation";
import { useTranslation } from "react-i18next";

const UiuxPricing = () => {
  const { t, i18n } = useTranslation();

  return (
    <StyledPricing.Container>
      <StyledPricing.Description>
        <p>
          <StyledPricing.Title lang={i18n.language}>
            {t("uiuxPricing.title")}
          </StyledPricing.Title>

          {t("uiuxPricing.intro1")}
          {" "}
          {t("uiuxPricing.intro2")}
          {" "}
          {t("uiuxPricing.intro3")}

          <ul>
            {[
              "needs",
              "sketch",
              "review",
              "wireframe",
              "finalDesign"
            ].map((step) => (
              <li key={step}>
                <TrueIcon color={"#caa037"} width={14} height={14} />
                <span>{t(`uiuxPricing.steps.${step}`)}</span>
              </li>
            ))}
          </ul>

          {t("uiuxPricing.conclusion")}
        </p>
      </StyledPricing.Description>

      <StyledPricing.PricingTable>
        <StyledPricing.Table>
          <thead>
            <StyledPricing.HeaderRow>
              <StyledPricing.HeaderCell></StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("uiuxPricing.table.basic")}
              </StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("uiuxPricing.table.standard")}
              </StyledPricing.HeaderCell>
            </StyledPricing.HeaderRow>
          </thead>

          <tbody>
            {[
              ["revisions", "one", "three"],
              ["pages", "five", "ten"],
              ["productType", "webOrApp", "webOrApp"],
              ["timeline", "twoWeeks", "fourWeeks"],
            ].map(([label, basic, standard]) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`uiuxPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`uiuxPricing.table.${basic}`)}
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`uiuxPricing.table.${standard}`)}
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Included in Both */}
            {[
              "responsive",
              "wireframes",
              "mockup",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`uiuxPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Standard Only */}
            {[
              "prototyping",
              "darkMode",
              "motion",
              "brand",
              "uiKit",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`uiuxPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><FalseIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            <StyledPricing.Row>
              <StyledPricing.Cell></StyledPricing.Cell>
              <StyledPricing.Cell>{t("uiuxPricing.table.price-basic")}</StyledPricing.Cell>
              <StyledPricing.Cell>{t("uiuxPricing.table.price-standard")}</StyledPricing.Cell>
            </StyledPricing.Row>
          </tbody>
        </StyledPricing.Table>
      </StyledPricing.PricingTable>

      <div>
        <Consultation text={
          <>
            {t("customPackage")}
            <br />
            {t("contactus")}
          </>
        } />
      </div>
    </StyledPricing.Container>
  );
};

export default UiuxPricing;